import React from 'react';
import { useSearchParams } from 'react-router-dom';
import FinanceSummaryPage from './FinanceSummaryPage';
import TransactionsPage from './TransactionsPage';
import PayrollPage from './PayrollPage';
import InvoicesPage from './InvoicesPage';
import QuotesPage from './QuotesPage';
import FinanceReportsPage from './FinanceReportsPage';
import Icon from '../../../components/dashboard/DashboardIcons';

const TABS = [
  { key: 'summary', label: 'الملخص المالي', icon: 'banknotes' },
  { key: 'expenses', label: 'المصروفات', icon: 'arrowDown' },
  { key: 'revenues', label: 'الإيرادات', icon: 'arrowUp' },
  { key: 'payroll', label: 'الرواتب', icon: 'wallet' },
  { key: 'invoices', label: 'الفواتير', icon: 'document' },
  { key: 'quotes', label: 'عروض الأسعار', icon: 'document' },
  { key: 'reports', label: 'التقارير المالية', icon: 'chart' },
];
const TAB_KEYS = TABS.map((t) => t.key);

/** صفحة موحّدة لكل أقسام الإدارة المالية — رابط واحد بالقائمة الجانبية، تبويبات داخلية بدل صفحات منفصلة */
export default function FinanceHubPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = TAB_KEYS.includes(searchParams.get('tab')) ? searchParams.get('tab') : 'summary';

  const setActiveTab = (key) => setSearchParams({ tab: key }, { replace: true });

  return (
    <div className="space-y-5" data-testid="finance-hub-page">
      <div>
        <h1 className="text-xl font-bold text-slate-900">الإدارة المالية</h1>
        <p className="text-sm text-slate-500">كل ما يخص الشأن المالي للمنشأة في مكان واحد</p>
      </div>

      <div className="flex gap-1 overflow-x-auto rounded-xl border border-slate-200 bg-white p-1.5" data-testid="finance-hub-tabs">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => setActiveTab(t.key)}
            data-testid={`finance-hub-tab-${t.key}`}
            className={`flex shrink-0 items-center gap-1.5 rounded-lg px-3 py-2 text-sm font-semibold transition-colors ${
              activeTab === t.key ? 'bg-[#16233b] text-white' : 'text-slate-600 hover:bg-slate-50'
            }`}
          >
            <Icon name={t.icon} className="h-4 w-4" />
            {t.label}
          </button>
        ))}
      </div>

      <div data-testid="finance-hub-content">
        {activeTab === 'summary' && <FinanceSummaryPage />}
        {activeTab === 'expenses' && <TransactionsPage kind="expense" />}
        {activeTab === 'revenues' && <TransactionsPage kind="revenue" />}
        {activeTab === 'payroll' && <PayrollPage />}
        {activeTab === 'invoices' && <InvoicesPage />}
        {activeTab === 'quotes' && <QuotesPage />}
        {activeTab === 'reports' && <FinanceReportsPage />}
      </div>
    </div>
  );
}
